import React from 'react';
import { View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import Text from '../../../components/text/Text';
import { useTheme } from '../../../theme';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const joinList = items => items.join(', ');

/**
 * StopSyncNote: what this stop has saved on the phone and not yet synced
 * (getStopSyncState). Pass it in Screen's `banner` slot, above the dock.
 * Props: pending (strings), failed (strings), isOnline
 */
const StopSyncNote = ({ pending, failed, isOnline }) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();

	if (!pending?.length && !failed?.length) {
		return null;
	}

	return (
		<View style={styles.note}>
			{pending?.length > 0 && (
				<View style={styles.row} accessible={true}>
					<Feather name="smartphone" size={18} color={colors.iconMuted} />
					<Text style={styles.text}>
						{`Saved on phone, ${isOnline ? 'syncing' : 'will sync when back online'}: ${joinList(pending)}`}
					</Text>
				</View>
			)}
			{failed?.length > 0 && (
				<View style={styles.row} accessible={true}>
					<Feather name="alert-circle" size={18} color={colors.danger} />
					<Text style={[styles.text, styles.failedText]}>
						{`Not synced: ${joinList(failed)}. Tap the pending updates bar to retry.`}
					</Text>
				</View>
			)}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space, layout } }) => ({
	note: {
		width: '100%',
		maxWidth: layout.maxContentWidth,
		alignSelf: 'center',
		gap: space.xs,
		paddingHorizontal: space.gutter,
		paddingVertical: space.sm,
	},
	row: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: space.sm,
	},
	text: {
		...type.secondary,
		color: colors.textSecondary,
		flex: 1,
	},
	failedText: {
		color: colors.danger,
	},
});

export default StopSyncNote;
